import { AutoshipsHeader } from 'features/dashboard/widgets/firstline/headers/AutoshipHeaders';
import { CurrentQualificationHeader } from 'features/dashboard/widgets/firstline/headers/QualificationHeaders';
import {
  CustomerRegistrationsHeader,
  QuickstartRegistrationsHeader,
  TPRegistrationsHeader
} from 'features/dashboard/widgets/firstline/headers/RegistrationHeaders';
import {
  PersonalSalesHeader,
  SixLevelSalesHeader,
  StructureSalesHeader
} from 'features/dashboard/widgets/firstline/headers/SalesHeaders';
import { FC } from 'react';

export const HistoryTableSkeleton: FC = () => {
  return (
    <div className="mt-8 flow-root overflow-y-auto">
      <div className="overflow-x-auto">
        <div className="inline-block min-w-full align-middle bg-lightGray">
          <table className="min-w-full divide-y divide-slate-100 border border-slate-100">
            <thead className="bg-white">
              <tr className="divide-x divide-slate-100 uppercase overflow-hidden whitespace-nowrap text-ellipsis text-middle">
                <th scope="col" className="py-3.5 px-2 text-left text-sm"></th>

                <th className="text-md font-medium text-gray-900 p-2 text-middle">
                  <CurrentQualificationHeader iconOnly />
                </th>

                <th
                  className="text-md font-medium text-gray-900 p-2 text-middle"
                  colSpan={2}
                >
                  <AutoshipsHeader />
                </th>
                <th
                  className="text-md font-medium text-gray-900 p-2 text-middle"
                  colSpan={2}
                >
                  <StructureSalesHeader />
                </th>

                <th
                  className="text-md font-medium text-gray-900 p-2 text-middle"
                  colSpan={2}
                >
                  <SixLevelSalesHeader />
                </th>

                <th
                  className="text-md font-medium text-gray-900 p-2 text-middle"
                  colSpan={2}
                >
                  <PersonalSalesHeader />
                </th>

                <th
                  className="text-md font-medium text-gray-900 p-2 text-middle"
                  colSpan={2}
                >
                  <TPRegistrationsHeader />
                </th>

                <th
                  className="text-md font-medium text-gray-900 p-2 text-middle"
                  colSpan={2}
                >
                  <CustomerRegistrationsHeader />
                </th>

                <th
                  className="text-md font-medium text-gray-900 p-2 text-middle"
                  colSpan={2}
                >
                  <QuickstartRegistrationsHeader />
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 bg-white">
              {Array.from(Array(10).keys()).map(key => {
                return (
                  <tr
                    key={`${key}`}
                    className="odd:bg-white even:bg-slate-50 divide-x divide-slate-100 whitespace-nowrap text-sm"
                  >
                    <td className="p-2 font-bold">
                      <div className="bg-lightGray h-3.5 w-12 animate-pulse" />
                    </td>

                    <td className="p-2 text-center">
                      <div className="bg-lightGray h-3.5 w-12 animate-pulse" />
                    </td>

                    <td className="p-2 text-right">
                      <div className="bg-lightGray h-3.5 w-12 animate-pulse" />
                    </td>

                    <td className="p-2">
                      <div className="bg-lightGray h-5 w-8 animate-pulse" />
                    </td>

                    <td className="p-2 text-right">
                      <div className="bg-lightGray h-3.5 w-12 animate-pulse" />
                    </td>

                    <td className="p-2">
                      <div className="bg-lightGray h-5 w-8 animate-pulse" />
                    </td>

                    <td className="p-2 text-right">
                      <div className="bg-lightGray h-3.5 w-12 animate-pulse" />
                    </td>

                    <td className="p-2">
                      <div className="bg-lightGray h-5 w-8 animate-pulse" />
                    </td>

                    <td className="p-2 text-right">
                      <div className="bg-lightGray h-3.5 w-12 animate-pulse" />
                    </td>

                    <td className="p-2">
                      <div className="bg-lightGray h-5 w-8 animate-pulse" />
                    </td>

                    <td className="p-2 text-right">
                      <div className="bg-lightGray h-3.5 w-12 animate-pulse" />
                    </td>

                    <td className="p-2">
                      <div className="bg-lightGray h-5 w-8 animate-pulse" />
                    </td>

                    <td className="p-2 text-right">
                      <div className="bg-lightGray h-3.5 w-12 animate-pulse" />
                    </td>

                    <td className="p-2">
                      <div className="bg-lightGray h-5 w-8 animate-pulse" />
                    </td>

                    <td className="p-2 text-right">
                      <div className="bg-lightGray h-3.5 w-12 animate-pulse" />
                    </td>

                    <td className="p-2">
                      <div className="bg-lightGray h-5 w-8 animate-pulse" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
